<template>
  <section class="section pt-5">
    <patient-datatable />
  </section>
</template>

<script>
import PatientDatatable from "./patient_datatable/Index.vue";

export default {
  name: "PatientIndex",
  components: { PatientDatatable },
  data() {
    return {
      is_loading: false,
    };
  },
  methods: {
    retrieve_settings() {
      // get_configuration(this)
      //   .then((conf) => {
      //     console.log("configuration retrieved", conf);
      //   })
      //   .catch((error) => {
      //     console.error(error);
      //   });
    },
    create() {
      console.log("create order");
    },
    refresh() {
      console.log("refresh orders");
    },
  },
  mounted() {},
  created() {},
};
</script>

<style scoped></style>
